module.exports = ":host /deep/ .index-column, :host /deep/ .index-column-header {\r\n\ttext-align: right;\r\n}\r\n\r\n:host /deep/ .data-table .data-table-row.selected {\r\n\tbackground-color: #E4EDF9;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/record-data-table/record-data-table.component.css
// module id = ./src/app/core/record-data-table/record-data-table.component.css
// module chunks = main